/**
 * @flow
 * @relayHash e35d8ccb192c70b484733e48131eed19
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateEstimateInput = {
  clientMutationId?: ?string,
  id: string,
  title?: ?string,
  notes?: ?string,
  recipient_first_name?: ?string,
  recipient_last_name?: ?string,
  recipient_company_name?: ?string,
  recipient_phone?: ?string,
  recipient_email?: ?string,
  recipient_address?: ?string,
  hide_total?: ?boolean,
};
export type Title_UpdateEstimateMutationVariables = {|
  input: UpdateEstimateInput
|};
export type Title_UpdateEstimateMutationResponse = {|
  +updateEstimate: ?{|
    +estimate: ?{|
      +title: ?string
    |}
  |}
|};
export type Title_UpdateEstimateMutation = {|
  variables: Title_UpdateEstimateMutationVariables,
  response: Title_UpdateEstimateMutationResponse,
|};
*/


/*
mutation Title_UpdateEstimateMutation(
  $input: UpdateEstimateInput!
) {
  updateEstimate(input: $input) {
    estimate {
      title
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateEstimateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateEstimateInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "Title_UpdateEstimateMutation",
  "id": null,
  "text": "mutation Title_UpdateEstimateMutation(\n  $input: UpdateEstimateInput!\n) {\n  updateEstimate(input: $input) {\n    estimate {\n      title\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Title_UpdateEstimateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateEstimate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateEstimatePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimate",
            "storageKey": null,
            "args": null,
            "concreteType": "Estimate",
            "plural": false,
            "selections": [
              v2
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "Title_UpdateEstimateMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateEstimate",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateEstimatePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimate",
            "storageKey": null,
            "args": null,
            "concreteType": "Estimate",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6fd6f72f9df5d73b0a7daffcb52e5c49';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Estimate/__generated__/Title_UpdateEstimateMutation.graphql.js